var utils  = require( './utils' ),
	header = require( './sticky-header' );

var event_archive_map = ( function( $ ) {

	var $toggle_container;

	var _init = function() {
		$toggle_container = $( '.archive-map-toggle' );
		$toggle_container.find( 'a.toggle-link' ).on( 'click', _toggle );
	};
	
	var _toggle = function( e ) {
		e.preventDefault();

		if ( $toggle_container.hasClass( 'open' ) ) {
			_close_panel();
		} else {
			_open_panel();
		}
	};

	var _close_panel = function(  ) {
		$toggle_container.find( '.toggle-panel' ).animate( {
			height : 0
		}, 500 );

		$toggle_container.removeClass( 'open' );

		$toggle_container.find( '.toggle-link' ).text( 'View on map' );
	};

	var _open_panel = function() {
		var height_to = $toggle_container.outerWidth();

		$toggle_container.find( '.toggle-panel' ).animate( {
			height :height_to
		}, 500 );

		$toggle_container.find( '.toggle-link' ).text( 'Hide map' );

		$toggle_container.addClass( 'open' );
	};

	if ( $( '#archive-map' ).length > 0 ) {
		$( document ).ready( _init );
	}
	
} ) ( jQuery );

module.exports = event_archive_map;